import { Town } from "@models";
import { townService } from "@services";
import { makeAutoObservable, runInAction } from "mobx";

export default class TownStore {
  towns: Town[] = [];
  loading = false;
  /** Lista gradova je jednom učitana u ovoj sesiji. */
  loaded = false;

  /**
   * Gradovi se ne menjaju tokom sesije, a `useTowns` se poziva sa više mesta
   * odjednom (scena + `TownSelect`). Bez ovoga svaki od njih šalje svoj
   * `GetAll`, pa je isti spisak išao 2-3 puta po otvaranju stranice.
   * Namerno nije observable — služi samo za deljenje zahteva u letu.
   */
  inflight: Promise<void> | null = null;

  constructor() {
    makeAutoObservable(this, { inflight: false });
  }

  getAll = async (force = false) => {
    if (!force && this.loaded) return;
    if (this.inflight) return this.inflight;

    runInAction(() => {
      this.loading = true;
    });

    this.inflight = (async () => {
      try {
        const response = await townService.getAll();
        runInAction(() => {
          this.towns = response;
          this.loaded = true;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.inflight = null;
        runInAction(() => {
          this.loading = false;
        });
      }
    })();

    return this.inflight;
  };
}
